export const FAQ_BLOCK = [
  {
    q: "Who is Home AI for?",
    a: "Homeowners, buyers, landlords and property developers who want a faster, data-led way to sell or find property. We are not a service for estate agents."
  },
  {
    q: "What exactly is Home AI?",
    a: "Home AI is an AI-assisted property platform. We combine licensed data, pricing models and human experts to value, market and sell property; and to help buyers discover homes that fit their brief. Your agent stays in control of all decisions."
  },
  {
    q: "How do I get a valuation?",
    a: "Create an account and add your property details (address, photos, recent works, key features). Our models generate a pricing range and recommended launch strategy, which a human specialist reviews before you approve."
  },
  {
    q: "Is there an upfront fee?",
    a: "Yes — there’s an upfront payment payable on contract signing. Your agreement will clearly set out what’s included (valuation, prep, marketing set-up, etc.)."
  },
  {
    q: "How long until my property goes live?",
    a: "Once you’ve approved pricing and provided required information, we typically launch within up to two weeks. This allows for photography, copy, compliance checks and listing prep."
  },
  {
    q: "I’ve submitted the interest form — what happens next?",
    a: "We’ll review your details and reach out inside your account to confirm next steps. If we need anything else, you’ll receive a prompt in the dashboard."
  },
  {
    q: "I’m a developer — can you help with multiple units or off-plan?",
    a: "Yes. We support developer briefs (off-plan and completed stock), phased releases, bulk enquiries, and unit-level pricing. Ask about tailored marketing packs and buyer profiling."
  },
  {
    q: "How do buyers use Home AI?",
    a: "Create a buyer profile to set budget, location and must-haves. You'll get price alerts for relevant listings and an AI-powered search that finds homes matching your criteria. Request viewings and chat with your agent to understand valuations and market insights."
  },
  {
    q: "Do you cover my area?",
    a: "We’re rolling out across the UK. Enter your postcode when you create an account; if we’re not live in your area yet, you can register interest and we’ll notify you as soon as we are."
  },
  {
    q: "What marketing do you handle for sellers?",
    a: "Professional photography, copywriting, listing distribution, targeted digital campaigns, and AI-assisted buyer matching. We coordinate viewings and gather structured feedback to refine pricing and positioning."
  },
  {
    q: "Who conducts viewings?",
    a: "We offer flexible options: hosted viewings by our team or owner-led time slots with our scheduling tools. We’ll recommend the best approach for your property and location."
  },
  {
    q: "How do offers and sales progression work?",
    a: "Offers are submitted and verified through your dashboard. Once you accept, we move into sales progression with solicitors, surveys and milestones tracked transparently in your account."
  },
  {
    q: "How are fees structured?",
    a: "Your contract sets out the upfront payment and any success-based fee on completion. There are no hidden extras; optional services (e.g., premium video) are itemised."
  },
  {
    q: "Can I withdraw my listing?",
    a: "Yes. You can request withdrawal through your account. Any notice periods or costs will be defined in your contract."
  },
  {
    q: "How do price alerts work?",
    a: "Set your criteria and we’ll notify you of price changes and new matches in real time. You can tweak or pause alerts any time from your profile."
  },
  {
    q: "How does Home AI use my data?",
    a: "We use your information to deliver valuations, matches and communication about your listing or search. We never sell personal data. See our Privacy Policy for full details."
  },
  {
    q: "How do I get support?",
    a: "Use the in-app chat from your dashboard. You can also submit a support request via the contact form; we’ll reply inside your account."
  }
];
